import { Component, Input } from "@angular/core";

@Component({
    selector: "app-error-page",
    standalone: true,
    imports: [],
    templateUrl: "./error-page.component.html",
    styleUrl: "./error-page.component.scss",
})
export class ErrorPageComponent {
    @Input() errorMessage: string = 'An error occurred. Please try again later.';
}

